import React from 'react';

import { getTableSortOrder } from '../../common/getTableSortOrder';
import { UserAvatar } from '../../components/InitialsBadgeTableCell';
import { LinkTableCell } from '../../components/LinkTableCell';
import { PageRoutesEnum } from '../../utils/routes';

import { ProjectType } from './ProjectsTable.types';

export const useProjectsTableColumnDefinitions = ({
  sortedInfo,
}: {
  sortedInfo: { field: string; order: string }[];
}) => {
  const projectColumns = [
    {
      title: 'Project',
      dataIndex: 'name',
      width: 160,
      sorter: {
        compare: () => 0,
        multiple: 1,
      },
      sortOrder: getTableSortOrder(sortedInfo, 'name'),
    },
    {
      title: 'Client',
      dataIndex: 'client.name',
      width: 140,
      sorter: {
        compare: () => 0,
        multiple: 1,
      },
      sortOrder: getTableSortOrder(sortedInfo, 'client.name'),
    },
    {
      title: 'Client employee',
      dataIndex: 'clientEmployee',
      width: 160,
    },
    {
      title: 'Recruiter',
      dataIndex: 'recruiters',
      width: 120,
      render: (recruiters: ProjectType['recruiters']) => (
        <div style={{ display: 'flex', flexWrap: 'wrap', gap: '4px', padding: '16px' }}>
          {recruiters.map((recruiter) => (
            <UserAvatar key={recruiter.id} userName={`${recruiter.firstName} ${recruiter.lastName}`} withPopover />
          ))}
        </div>
      ),
    },
    {
      title: 'Sent CVs',
      dataIndex: 'clientCvCount',
      width: 120,
    },
    {
      title: 'Recruitments',
      dataIndex: 'recruitmentCount',
      width: 140,
    },
    {
      title: 'Created',
      dataIndex: 'createdDate',
      width: 120,
      sorter: {
        compare: () => 0,
        multiple: 1,
      },
      sortOrder: getTableSortOrder(sortedInfo, 'createdDate'),
    },
    {
      title: 'Priority',
      dataIndex: 'priority',
      width: 140,
      sorter: {
        compare: () => 0,
        multiple: 1,
      },
      sortOrder: getTableSortOrder(sortedInfo, 'priority'),
    },
  ];

  return projectColumns.map((column) => {
    if (column.render) {
      return column;
    }

    return {
      ...column,
      render: (text: string, record: unknown) => (
        <LinkTableCell text={text} record={record as { key: React.Key }} pageRoute={PageRoutesEnum.projectsEdit} />
      ),
    };
  });
};
